import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8f835c56"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "avatar" };
const _hoisted_2 = { class: "username" };
const _hoisted_3 = { class: "account-menu-header" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h6", null, "Account", -1));
import { computed, ref } from 'vue';
import Menu from 'primevue/menu';
import UserIcon from '@apparatix/icons/UserIcon.vue';
import UserMasqueradeModal from '@apparatix/library/UserMasqueradeModal.vue';
import AccountSettings from '@apparatix/library/AccountSettings.vue';
import { AppStore } from '@apparatix/stores/AppStore';
import { useAppNavigation, useImpersonation } from '@apparatix/composables';
import { menuBaseTheme } from '@apparatix/theme/menuBaseTheme';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AccountMenu',
    props: {
        username: {}
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "21c44c7c": (profileHoverColor.value),
            "1dcc05bc": (profileActiveColor.value)
        }));
        const { logOut } = useAppNavigation();
        const { disableImpersonation, hasPermission } = useImpersonation(AppStore.realUser);
        const props = __props;
        const menuRef = ref();
        const isOpen = ref(false);
        const isMobileEditModeEnabled = ref(false);
        const showMasqueradeModal = ref(false);
        const showAccountSettings = ref(false);
        const onBlur = () => {
            isOpen.value = false;
        };
        const mobileEditLabel = computed(() => isMobileEditModeEnabled.value ? 'Disable Mobile Edit Mode' : 'Enable Mobile Edit Mode');
        const toggleMenu = (e) => {
            menuRef.value.toggle(e);
            isOpen.value = !isOpen.value;
        };
        const profileActiveColor = computed(() => {
            if (isOpen.value) {
                return 'var(--white-12)';
            }
            return 'transparent';
        });
        const profileHoverColor = computed(() => {
            if (isOpen.value)
                return 'var(--white-12)';
            return 'var(--white-08)';
        });
        const onCloseMasqueradeModal = () => showMasqueradeModal.value = false;
        const menuItems = computed(() => {
            const items = [
                {
                    label: 'Account Settings',
                    command: () => {
                        // AppStore.shouldShowSidebar = false;
                        // AppStore.setActiveSubPage({
                        //   label: '',
                        //   url: '/iframe-wrapper/account',
                        //   uuid: undefined,
                        //   parentUuid: undefined,
                        // });
                        showAccountSettings.value = !showAccountSettings.value;
                    },
                },
                { separator: true },
                {
                    label: mobileEditLabel.value,
                    command: () => {
                        isMobileEditModeEnabled.value = !isMobileEditModeEnabled.value,
                            window._gridGlobalLightNavigationEnabled = isMobileEditModeEnabled.value;
                    },
                },
                { label: 'Enable Debug Mode' },
                {
                    label: 'Log out',
                    command: () => logOut(),
                },
            ];
            if (hasPermission) {
                items.splice(1, 0, {
                    label: AppStore.isImpersonating ? 'Disable impersonation' : 'Switch user',
                    command: () => {
                        if (!AppStore.isImpersonating) {
                            showMasqueradeModal.value = true;
                        }
                        else {
                            disableImpersonation();
                        }
                    },
                });
            }
            return items;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: _normalizeClass(["container", { active: isOpen.value }]),
                    onClick: toggleMenu
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(UserIcon)
                    ]),
                    _createElementVNode("span", _hoisted_2, _toDisplayString(props.username), 1)
                ], 2),
                _createVNode(_unref(Menu), {
                    ref_key: "menuRef",
                    ref: menuRef,
                    model: menuItems.value,
                    popup: true,
                    unstyled: "",
                    pt: _unref(menuBaseTheme),
                    onBlur: onBlur
                }, {
                    start: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("p", null, _toDisplayString(_unref(AppStore).currentUser.displayName), 1),
                            _createElementVNode("span", null, _toDisplayString(_unref(AppStore).currentUser.email), 1)
                        ])
                    ]),
                    _: 1
                }, 8, ["model", "pt"]),
                (showMasqueradeModal.value)
                    ? (_openBlock(), _createBlock(UserMasqueradeModal, {
                        key: 0,
                        visible: showMasqueradeModal.value,
                        "on-close": onCloseMasqueradeModal
                    }, null, 8, ["visible"]))
                    : _createCommentVNode("", true),
                _createVNode(AccountSettings, {
                    visible: showAccountSettings.value,
                    user: { displayName: _unref(AppStore).currentUser.displayName, username: _unref(AppStore).currentUser.username },
                    onUpdateVisible: _cache[0] || (_cache[0] = e => showAccountSettings.value = e)
                }, null, 8, ["visible", "user"])
            ], 64));
        };
    }
});
